import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})

export class Util {

  public static GetBaseUrl() {
    //let baseurl = "http://localhost:8080";
    let baseurl = "https://exam2x-beta.azurewebsites.net";
    return baseurl;
  }


  public static ConvertDate(Value: any) {

  }
}
